import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetSecondarySectors = createAsyncThunk(
  "PersonalInformation/GetSecondarySectors",
  async (aI_SecondarySectorsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_SecondarySectors/GetAI_SecondarySectors",
        {
          aI_SecondarySectorsId: aI_SecondarySectorsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateAI_SecondarySectors = createAsyncThunk(
  "AI_SecondarySectors/ValidateAI_SecondarySectors",
  async (aI_SecondarySectorsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_SecondarySectors/ValidateAI_SecondarySectors",
        {
          aI_MainSectorId: aI_SecondarySectorsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log( response.data, "dataaaaaaaaa");
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
            return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const DeleteListAI_SecondarySectors = createAsyncThunk(
    "AI_SecondarySectors/DeleteListAI_SecondarySectors",
    async (aI_ApplicationInformationId, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/AI_SecondarySectors/DeleteListAI_SecondarySectors",
          {
            aI_ApplicationInformationId: aI_ApplicationInformationId,
          }
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
     
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const SecondarySectors = createSlice({
  name: "SecondarySectors",
  initialState: {
    aI_SecondarySectors: {},
    loadingaI_SecondarySectors: false,
    erroraI_SecondarySectors: null,

    aI_SecondarySectorsValidate: [],
    loadingaI_SecondarySectorsValidate: false,
    erroraI_SecondarySectorsValidate: null,

    aI_SecondarySectorsDelete: {},
    loadingaI_SecondarySectorsDelete: false,
    erroraI_SecondarySectorsDelete: null,
  },
  reducers: {
    restSecondarySectorsValidate:(state,action)=>{
      state.aI_SecondarySectorsValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetSecondarySectors.pending, (state, action) => {
        state.loadingaI_SecondarySectors = true;
        state.aI_SecondarySectors = action.payload;
        state.erroraI_SecondarySectors = null;
      })
      .addCase(GetSecondarySectors.fulfilled, (state, action) => {
        state.loadingaI_SecondarySectors = false;
        state.aI_SecondarySectors = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSecondarySectors.rejected, (state, action) => {
        state.loadingaI_SecondarySectors = false;
        state.erroraI_SecondarySectors = action.payload;
      })

      .addCase(ValidateAI_SecondarySectors.pending, (state, action) => {
        state.loadingaI_SecondarySectorsValidate = true;
        state.aI_SecondarySectorsValidate = action.payload;
        state.erroraI_SecondarySectorsValidate = null;
      })
      .addCase(ValidateAI_SecondarySectors.fulfilled, (state, action) => {
        state.loadingaI_SecondarySectorsValidate = false;
        state.aI_SecondarySectorsValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateAI_SecondarySectors.rejected, (state, action) => {
        state.loadingaI_SecondarySectorsValidate = false;
        state.aI_SecondarySectorsValidate = action.payload;
      })

      .addCase(DeleteListAI_SecondarySectors.pending, (state, action) => {
        state.loadingaI_SecondarySectorsDelete = true;
        state.aI_SecondarySectorsDelete = action.payload;
        state.erroraI_SecondarySectorsDelete = null;
      })
      .addCase(DeleteListAI_SecondarySectors.fulfilled, (state, action) => {
        state.loadingaI_SecondarySectorsDelete = false;
        state.aI_SecondarySectorsDelete = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteListAI_SecondarySectors.rejected, (state, action) => {
        state.loadingaI_SecondarySectorsDelete = false;
        state.aI_SecondarySectorsDelete = action.payload;
      });
  },
});
export const { restSecondarySectorsValidate } = SecondarySectors.actions;
export default SecondarySectors.reducer;
